"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_UPDATE_SUBMISSION_ART_MUTATION = exports.AdminSubmissionUpdateArtInputGql = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.AdminSubmissionUpdateArtInputGql = (0, graphql_tag_1.default) `
  input AdminSubmissionUpdateArtInput {
    id: UUID!
    gameCovers: [GameCoverWithUploadedFileInput!]!
    videos: SubmissionVideoInput
    removeLiveVideos: Boolean!
  }
`;
exports.ADMIN_UPDATE_SUBMISSION_ART_MUTATION = (0, graphql_tag_1.default) `
  mutation updateSubmission($input: AdminSubmissionUpdateArtInput!) {
    adminSubmissionUpdateArt(input: $input) {
      id
    }
  }
`;
